/**
 * A guard built by a factory has no stable identity, so a route that lists one cannot be
 * recognised by the `includes` checks that match guards by reference. A composing guard
 * declares what it wraps here, and those checks keep working.
 */
const COMPOSED_GUARDS = Symbol('composedGuards');

export const composesGuards = <TGuard extends (...args: never[]) => unknown>(
  guard: TGuard,
  composed: readonly unknown[]
): TGuard => Object.assign(guard, { [COMPOSED_GUARDS]: composed });

export const getComposedGuards = (guard: unknown): readonly unknown[] =>
  typeof guard === 'function' && COMPOSED_GUARDS in guard
    ? ((guard as Record<symbol, readonly unknown[]>)[COMPOSED_GUARDS] ?? [])
    : [];
